"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEstimateBracketResult = instanceOfEstimateBracketResult;
exports.EstimateBracketResultFromJSON = EstimateBracketResultFromJSON;
exports.EstimateBracketResultFromJSONTyped = EstimateBracketResultFromJSONTyped;
exports.EstimateBracketResultToJSON = EstimateBracketResultToJSON;
exports.EstimateBracketResultToJSONTyped = EstimateBracketResultToJSONTyped;
const variant_1 = require("./variant");
const bracketTagEnum_1 = require("./bracketTagEnum");
const card_1 = require("./card");
/**
 * Check if a given object implements the EstimateBracketResult interface.
 */
function instanceOfEstimateBracketResult(value) {
    if (!('bracketTag' in value) || value['bracketTag'] === undefined)
        return false;
    if (!('gameChangerCards' in value) || value['gameChangerCards'] === undefined)
        return false;
    if (!('massLandDenialCards' in value) || value['massLandDenialCards'] === undefined)
        return false;
    if (!('massLandDenialTemplates' in value) || value['massLandDenialTemplates'] === undefined)
        return false;
    if (!('massLandDenialCombos' in value) || value['massLandDenialCombos'] === undefined)
        return false;
    if (!('extraTurnCards' in value) || value['extraTurnCards'] === undefined)
        return false;
    if (!('extraTurnTemplates' in value) || value['extraTurnTemplates'] === undefined)
        return false;
    if (!('extraTurnsCombos' in value) || value['extraTurnsCombos'] === undefined)
        return false;
    if (!('tutorCards' in value) || value['tutorCards'] === undefined)
        return false;
    if (!('tutorTemplates' in value) || value['tutorTemplates'] === undefined)
        return false;
    if (!('lockCombos' in value) || value['lockCombos'] === undefined)
        return false;
    if (!('skipTurnsCombos' in value) || value['skipTurnsCombos'] === undefined)
        return false;
    if (!('definitelyEarlyGameTwoCardCombos' in value) || value['definitelyEarlyGameTwoCardCombos'] === undefined)
        return false;
    if (!('arguablyEarlyGameTwoCardCombos' in value) || value['arguablyEarlyGameTwoCardCombos'] === undefined)
        return false;
    if (!('definitelyLateGameTwoCardCombos' in value) || value['definitelyLateGameTwoCardCombos'] === undefined)
        return false;
    if (!('borderlineLateGameTwoCardCombos' in value) || value['borderlineLateGameTwoCardCombos'] === undefined)
        return false;
    return true;
}
function EstimateBracketResultFromJSON(json) {
    return EstimateBracketResultFromJSONTyped(json, false);
}
function EstimateBracketResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bracketTag': (0, bracketTagEnum_1.BracketTagEnumFromJSON)(json['bracketTag']),
        'gameChangerCards': (json['gameChangerCards'].map(card_1.CardFromJSON)),
        'massLandDenialCards': (json['massLandDenialCards'].map(card_1.CardFromJSON)),
        'massLandDenialTemplates': (json['massLandDenialTemplates'].map(variant_1.VariantFromJSON)),
        'massLandDenialCombos': (json['massLandDenialCombos'].map(variant_1.VariantFromJSON)),
        'extraTurnCards': (json['extraTurnCards'].map(card_1.CardFromJSON)),
        'extraTurnTemplates': (json['extraTurnTemplates'].map(variant_1.VariantFromJSON)),
        'extraTurnsCombos': (json['extraTurnsCombos'].map(variant_1.VariantFromJSON)),
        'tutorCards': (json['tutorCards'].map(card_1.CardFromJSON)),
        'tutorTemplates': (json['tutorTemplates'].map(variant_1.VariantFromJSON)),
        'lockCombos': (json['lockCombos'].map(variant_1.VariantFromJSON)),
        'skipTurnsCombos': (json['skipTurnsCombos'].map(variant_1.VariantFromJSON)),
        'definitelyEarlyGameTwoCardCombos': (json['definitelyEarlyGameTwoCardCombos'].map(variant_1.VariantFromJSON)),
        'arguablyEarlyGameTwoCardCombos': (json['arguablyEarlyGameTwoCardCombos'].map(variant_1.VariantFromJSON)),
        'definitelyLateGameTwoCardCombos': (json['definitelyLateGameTwoCardCombos'].map(variant_1.VariantFromJSON)),
        'borderlineLateGameTwoCardCombos': (json['borderlineLateGameTwoCardCombos'].map(variant_1.VariantFromJSON)),
    };
}
function EstimateBracketResultToJSON(json) {
    return EstimateBracketResultToJSONTyped(json, false);
}
function EstimateBracketResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'bracketTag': (0, bracketTagEnum_1.BracketTagEnumToJSON)(value['bracketTag']),
        'gameChangerCards': (value['gameChangerCards'].map(card_1.CardToJSON)),
        'massLandDenialCards': (value['massLandDenialCards'].map(card_1.CardToJSON)),
        'massLandDenialTemplates': (value['massLandDenialTemplates'].map(variant_1.VariantToJSON)),
        'massLandDenialCombos': (value['massLandDenialCombos'].map(variant_1.VariantToJSON)),
        'extraTurnCards': (value['extraTurnCards'].map(card_1.CardToJSON)),
        'extraTurnTemplates': (value['extraTurnTemplates'].map(variant_1.VariantToJSON)),
        'extraTurnsCombos': (value['extraTurnsCombos'].map(variant_1.VariantToJSON)),
        'tutorCards': (value['tutorCards'].map(card_1.CardToJSON)),
        'tutorTemplates': (value['tutorTemplates'].map(variant_1.VariantToJSON)),
        'lockCombos': (value['lockCombos'].map(variant_1.VariantToJSON)),
        'skipTurnsCombos': (value['skipTurnsCombos'].map(variant_1.VariantToJSON)),
        'definitelyEarlyGameTwoCardCombos': (value['definitelyEarlyGameTwoCardCombos'].map(variant_1.VariantToJSON)),
        'arguablyEarlyGameTwoCardCombos': (value['arguablyEarlyGameTwoCardCombos'].map(variant_1.VariantToJSON)),
        'definitelyLateGameTwoCardCombos': (value['definitelyLateGameTwoCardCombos'].map(variant_1.VariantToJSON)),
        'borderlineLateGameTwoCardCombos': (value['borderlineLateGameTwoCardCombos'].map(variant_1.VariantToJSON)),
    };
}
//# sourceMappingURL=estimateBracketResult.js.map